import moment from "jalali-moment";

export const isAdmin = (role) => {
  if (role === "admin" || role === "superadmin") {
    return true;
  } else {
    return false;
  }
};

export const replaceSecAuthToken = () => {
  localStorage.setItem("token", getSecAuthToken());
  return true;
};
export const storeSecAuthToken = () => {
  localStorage.setItem("token_sec", getAuthToken());
  return true;
};
export const getSecAuthToken = () => {
  let token = localStorage.getItem("token_sec");
  return token;
};
export const storeAuthToken = (token) => {
  localStorage.setItem("token", token);
  return true;
};
export const getAuthToken = () => {
  return localStorage.getItem("token");
};
export const removeToken = () => {
  localStorage.setItem("token", "");
  return true;
};
export const removeSecToken = () => {
  localStorage.setItem("token_sec", "");
  return true;
};
export const removeMessengerToken = () => {
  localStorage.setItem("socketToken", "");
  localStorage.setItem("socketToken_expire", "");
  return true;
};

export const convertJdateToTimestamp = (date, time) => {
  date = date.replaceAll("-", "/");

  date = moment.from(`${date} ${time}`, "fa", "YYYY/MM/DD HH:mm");
  let timestamp = moment(date).format("X");

  return timestamp * 1000;
};

export const getOnlyumber = (num) => {
  if (num || num === 0) {
    if (!isNaN(Number(convertNumber(num)))) {
      return convertNumber(num)
        .toString()
        .replace(/[^0-9]/g, "");
    }
  } else {
    return "";
  }
};
export const convertNumber = (number, to = "en") => {
  try {
    if (to === "en")
      return number
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    else
      return number
        .replace(/[0-9]/g, (d) => "0123456789".indexOf(d))
        .replace(/[0-9]/g, (d) => "0123456789".indexOf(d));
  } catch (err) {
    return "";
  }
};

export const formatNumber = (num) => {
  if (num || num === 0) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return "";
  }
};

export const getFileNameFromUrl = (url) => {
  try {
    url = url.split("/");
    return url[url.length - 1];
  } catch (err) {
    return "";
  }
};

export const checkEmail = (email) => {
  let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return email.match(regexEmail);
};

export const openLoading = (_callBack = "") => {
  if (document.getElementById("loading")) {
    document.getElementById("loading").classList.remove("hidden");
  }

  if (typeof _callBack === "function") {
    _callBack();
  }
};
export const closeLoading = () => {
  if (document.getElementById("loading")) {
    document.getElementById("loading").classList.add("hidden");
  }
};

export const convertDateTrueFormat = (date) => {
  date = date.split("/");
  if (parseInt(date[1]) < 10) {
    date[1] = `0${parseInt(date[1])}`;
  }
  if (parseInt(date[2]) < 10) {
    date[2] = `0${parseInt(date[2])}`;
  }
  return date.join("/");
};

export const convertDate = (date, to) => {
  try {
    if (date === "" || date === null || date === undefined) return "";

    if (to === "en") {
      return moment.from(date, "fa", "YYYY/MM/DD").format("YYYY/MM/DD");
    } else {
      return moment(date, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    }
  } catch (err) {
    return "";
  }
};

export const createJalaliDate = (date) => {
  try {
    if (!date) return "";
    else return new moment(date).locale("fa").format("YYYY/MM/DD");
  } catch (err) {
    return "";
  }
};

export const getAge = (date) => {
  let years = moment(new Date()).diff(moment(date, "jYYYY/jMM/jDD"), "years");
  try {
    return years;
  } catch {
    return NaN;
  }
};

export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // fragment locator
  return !!pattern.test(str);
}

export function createNotification(notifications) {
  // notifications = [{text: '', type: ''}]
  // type: 'success', 'error', 'warning', 'primary'

  let notifArr = [];
  if (!Array.isArray(notifications) && notifications.trim().length > 0)
    notifArr = [notifications];
  else notifArr = notifications;

  notifArr.forEach((notif) => {
    let element = document.createElement("div");
    element.classList.add("notifBox");
    element.classList.add(notif.type);
    element.innerText = notif.text;
    if (document.getElementById("notificationSection")) {
      document.getElementById("notificationSection").appendChild(element);

      setTimeout(() => element.classList.add("show"), 200);
      setTimeout(() => element.classList.remove("show"), 5000);
      setTimeout(() => element.remove(), 5300);
    }
  });
}

export const getDaysNames = () => {
  return [
    { char: "ش", name: "شنبه" },
    { char: "ی", name: "یک شنبه" },
    { char: "د", name: "دوشنبه" },
    { char: "س", name: "سه شنبه" },
    { char: "چ", name: "چهارشنبه" },
    { char: "پ", name: "پنج شنبه" },
    { char: "ج", name: "جمعه" },
  ];
};

const sectionOptionsStudent = {
  eduTermic: "واحد آموزش زبان ترمیک",
  eduEspec: "واحد دوره های ویژه",
  examInter: "واحد آزمون بین المللی ÖSD",
  financial: "واحد مالی",
  support: "واحد پشتیبانی سایت و کلاس های انلاین",
  suggestion: "انتقادات و پیشنهادات",
  library: "واحد کتابخانه",

  // a1Exam: "زبان آموزان مبتدیان A1",
  // sis: "زبان آموزان ترم جاری (SIS)",
  // lastMehr: "زبان اموزان از مهر سال پیش تا تیرماه امسال",
};
const sectionOptionsTeacher = {
  librarySection: "واحد کتابخانه",
  supportSection: "واحد پشتیبانی",
  educationSection: "واحد آموزش",
  discountSection: "واحد تخفیف ها",
};

export const ticketSection = (type, name = "", access = "all") => {
  let sectionOptions = {};
  if (access === "student") {
    sectionOptions = sectionOptionsStudent;
  } else if (access === "teacher") {
    sectionOptions = sectionOptionsTeacher;
  } else {
    sectionOptions = { ...sectionOptionsStudent, ...sectionOptionsTeacher };
  }

  const priorityOptions = {
    HIGH: "زیاد",
    AVG: "متوسط",
    LOW: "کم",
  };

  if (type === "fullSection") {
    return sectionOptions;
  } else if (type === "fullPriority") {
    return priorityOptions;
  } else if (type === "selectedPriority") {
    if (priorityOptions.hasOwnProperty(name)) {
      return priorityOptions[name];
    }
  } else if (type === "selectSection") {
    if (sectionOptions.hasOwnProperty(name)) {
      return sectionOptions[name];
    }
  }

  return "";
};

export const getTypeOfTicketSections = (type) => {
  if (type === "teacher") {
    return Object.keys(sectionOptionsTeacher);
  } else if (type === "student") {
    return Object.keys(sectionOptionsStudent);
  } else {
    return [];
  }
};

let faCharacter = [
  "ض",
  "ص",
  "ث",
  "ق",
  "ف",
  "غ",
  "ع",
  "ه",
  "خ",
  "ح",
  "ج",
  "چ",
  "پ",
  "ژ",
  "ش",
  "س",
  "ی",
  "ب",
  "ل",
  "ا",
  "ت",
  "ن",
  "م",
  "ک",
  "گ",
  "ظ",
  "ط",
  "ز",
  "ر",
  "ذ",
  "د",
  "ئ",
  "و",
  "آ",
];
let someCahr = [".", "_", " ", "-"];

export const arrNumber = [
  "یک",
  "دو",
  "سه",
  "چهار",
  "پنج",
  "شش",
  "هفت",
  "هشت",
  "نه",
  "ده",
  "یازده",
];

export const arrNumber2 = [
  "اول",
  "دوم",
  "سوم",
  "چهارم",
  "پنجم",
  "ششم",
  "هفتم",
  "هشتم",
  "نهم",
  "دهم",
  "یازدهم",
];

export const color = [
  { color: "var(--emr-black)", name: "سیاه", enum: "BLACK" },
  { color: "var(--emr-green)", name: "سبز", enum: "GREEN" },
  { color: "var(--emr-blue)", name: "آبی", enum: "BLUE" },
  { color: "var(--emr-purple)", name: "بنفش", enum: "PURPLE" },
  { color: "var(--emr-yellow)", name: "زرد", enum: "YELLOW" },
  { color: "var(--emr-red)", name: "قرمز", enum: "RED" },
  { color: "var(--emr-lightblue)", name: "آبی کم رنگ", enum: "lightblue" },
];

export const getOnlyFa = (value) => {
  let checkArray = faCharacter.concat(someCahr);
  let enChar = true;
  for (let i = 0; i < value.length; i++) {
    if (value[i]) {
      let index = checkArray.indexOf(value[i]);
      if (index === -1) {
        enChar = false;
        break;
      }
    }
  }
  return enChar;
};
export const getOnlyNotFa = (value) => {
  let checkArray = faCharacter;
  let hasFa = false;
  for (let i = 0; i < value.length; i++) {
    if (value[i]) {
      if (checkArray.indexOf(value[i]) !== -1) {
        hasFa = true;
        break;
      }
    }
  }

  return !hasFa;
};

export const makeDownload = (link) => {
  var element = document.createElement("a");
  element.setAttribute("href", link);
  element.setAttribute("target", "_blank");

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const getOSDTags = () => {
  return [
    {
      t: "A1",
      value: "ZA1",
      color: "#FAC47F",
    },
    {
      t: "A1",
      value: "KID A1",
      color: "#F3983F",
    },
    {
      t: "A2",
      value: "ZA2",
      color: "#FFF49A",
    },
    {
      t: "A2",
      value: "KID A2",
      color: "#FFD400",
    },
    {
      t: "B1",
      value: "ZDÖ B1",
      color: "#E8348B",
    },
    {
      t: "B1",
      value: "ZB1",
      color: "#AEC90B",
    },
    {
      t: "B2",
      value: "ZB2",
      color: "#39A935",
    },
    {
      t: "C1",
      value: "ZC1",
      color: "#81CFF4",
    },
    {
      t: "C2",
      value: "ZC2",
      color: "#009EE2",
    },
  ];
};

export const getFileType = (file) => {
  let fileType = file.split(".").pop().toLowerCase();

  if (["png", "jpeg", "jpg", "webp", "svg"].indexOf(fileType) > -1) {
    return "img";
  } else if (["mp3"].indexOf(fileType) > -1) {
    return "voice";
  } else {
    return "other";
  }
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
